<template>
  <div class="audititem text-left">
    <b-modal
      id="Log4NetEvent"
      button-size="sm"
      size="xl"
      centered
      :title="'Log4Net Log Viewer'"
      v-model="modalShow"
      hide-footer
      no-stacking
      :modal-class="{ 'c-dark-theme': $store.state.darkMode }"
    >
      <!-- :border-variant="color" -->
      <div v-if="item">
        <b-card id="page" class="unbold printarea notifications">
          <div slot="header">
            <b-row align-v="center" no-gutters>
              <b-col cols="12">
                <strong>Date and Time:</strong>
                {{
                  $moment
                    .unix(item.date / 1000)
                    .utc(false)
                    .format("DD/MM/YY HH:mm:SS")
                }}
              </b-col>
              <!-- <b-col cols="1" class="text-right">
                <b-button
                  squared
                  variant="outline-primary"
                  size="sm"
                  @click="discard()"
                >
                  <i class="fa fa-compress"></i>
                </b-button>
              </b-col> -->
            </b-row>
          </div>

          <b-card-body v-if="item" class="py-0 px-0 availtable datatable">
            <b-tabs class="gridtabs">
              <b-tab active>
                <template #title>
                  <i class="fa fa-info text-primary mr-1"></i>
                  General
                </template>
                <p class="py-3 px-0">
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="ID" label-for="id" label-cols="12">
                        <b-input-group>
                          <b-form-input
                            type="text"
                            v-model="item.id"
                            placeholder="ID"
                            size="sm"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group
                        label="Thread"
                        label-for="thread"
                        label-cols="12"
                      >
                        <b-input-group>
                          <b-form-input
                            type="text"
                            v-model="item.thread"
                            placeholder="Thread"
                            size="sm"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group
                        label="Logger"
                        label-for="logger"
                        label-cols="12"
                      >
                        <b-input-group>
                          <b-form-input
                            type="text"
                            v-model="item.logger"
                            placeholder="logger"
                            size="sm"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group
                        label="Level"
                        label-for="level"
                        label-cols="12"
                      >
                        <b-input-group>
                          <b-form-input
                            type="text"
                            v-model="item.level"
                            placeholder="Level"
                            size="sm"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>
                      <b-form-group
                        label="Message"
                        label-for="message"
                        label-cols="12"
                      >
                        <b-input-group>
                          <span class="input_style pl-2">{{
                            item.message
                          }}</span>

                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row> -->
                  <b-row>
                    <b-col cols="12">
                      <b-form-group
                        label="Message"
                        label-for="message"
                        label-cols="12"
                      >
                        <b-form-textarea
                          id="data"
                          v-model="item.message"
                          placeholder="Enter message"
                          rows="8"
                          class="smalltextarea"
                          :disabled="true"
                        ></b-form-textarea>
                      </b-form-group> </b-col
                  ></b-row>
                </p>
              </b-tab>
              <b-tab>
                <template #title>
                  <i class="fa fa-database text-primary mr-1"></i>
                  Data</template
                >
                <p class="py-3 px-0 text-left">
                  <b-row class="break-word">
                    <b-col cols="12">
                      <b-form-group
                        label="Data"
                        label-for="data"
                        label-cols="12"
                      >
                        <vue-json-pretty :deep="1" :data="item.data">
                        </vue-json-pretty>
                      </b-form-group> </b-col
                  ></b-row></p
              ></b-tab>
              <b-tab>
                <template #title>
                  <i class="fa fa-exclamation-triangle text-danger mr-1"></i>
                  Exception
                </template>
                <p class="py-3 px-0">
                  <!-- <b-row>
                    <b-col cols="12">
                      <b-form-group
                        label="Exception"
                        label-for="exception"
                        label-cols="12"
                      >
                        <vue-json-pretty :deep="1" :data="item.exception">
                        </vue-json-pretty>
                      </b-form-group> </b-col
                  ></b-row> -->
                  <b-row class="break-word">
                    <b-col cols="12">
                      <b-form-group
                        label="Exception"
                        label-for="exception"
                        label-cols="12"
                      >
                        <b-form-textarea
                          id="exception"
                          v-model="item.exception"
                          placeholder="Exception"
                          rows="10"
                          class="smalltextarea"
                          :disabled="true"
                        ></b-form-textarea>
                      </b-form-group> </b-col
                  ></b-row></p
              ></b-tab>
            </b-tabs>
          </b-card-body>
        </b-card>
      </div>
    </b-modal>
  </div>
</template>


<script>
import gql from "graphql-tag";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  name: "Log4NetEvent",
  props: ["database", "selection"],
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      busy: false,
      modalShow: false,
      item: null,
      k: null,
      htmldata: null,
    };
  },
  watch: {
    modalShow: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.load();
      },
    },
  },
  methods: {
    async load() {
      this.busy = true;

      let variables = {
        database: this.database,
        id: this.selection[0].id,
      };
      console.log("variables", variables);
      const response = await this.$apollo.query({
        query: gql`
          query log4net($database: String, $id: String) {
            log4net(database: $database, id: $id) {
              id
              date
              thread
              level
              logger
              message
              exception
              data
            }
          }
        `,
        variables,
      });

      this.item = response.data.log4net[0];

      this.busy = false;
    },
  },
  // computed: {
  //   itemproperties() {
  //     let result = [];
  //     for (var property in this.item) {
  //       if (this.item.hasOwnProperty(property)) {
  //         result.push(property);
  //       }
  //     }
  //     return result;
  //   },
  //   color() {
  //     if (this.item.level || this.item.level == 0) {
  //       switch (this.item.level) {
  //         case "info":
  //           return "info";
  //         case "warning":
  //           return "warning";
  //         case "error":
  //           return "danger";
  //       }
  //     }
  //   },
  // },
  // <b-col cols="12" sm="6" md="4" xl="3">
  //                   <b-form-group
  //                     label-cols="12"
  //                     label="Date"
  //                     label-size="sm"
  //                     :disabled="readonly"
  //                   >
  //                     <b-input-group>
  //                       <b-form-datepicker
  //                         v-model="item.date"
  //                         size="sm"
  //                         label-help
  //                         hide-header
  //                         locale="en-GB"
  //                         placeholder="Select date"
  //                         :disabled="true"
  //                         :date-format-options="{
  //                           year: 'numeric',
  //                           month: 'numeric',
  //                           day: 'numeric',
  //                         }"
  //                       ></b-form-datepicker>

  //                     </b-input-group>
  //                   </b-form-group>
  //                 </b-col>

  //  <!-- <b-card-text>
  //           <div class="printheader">
  //             <div>
  //               <img
  //                 src="/img/brand/logo_trans.png"
  //                 title="Travel Places"
  //                 alt="Travel Places"
  //               />
  //             </div>
  //             <strong>RE: {{ item.message }}</strong>
  //             <br />
  //             <br />
  //           </div>
  //           <div v-if="item.data" class="pl-4 py-2">

  //             <div v-html="htmldata" class="auditdata"></div>
  //           </div>
  //           <div v-else class="pl-4">There are no further details to show</div>
  //         </b-card-text> -->

  // <!-- <b-row>
  //   <b-col cols="12">
  //     <b-form-group label="Data" label-for="data" label-cols="12">
  //       <b-form-textarea
  //         id="data"
  //         v-model="item.data"
  //         placeholder="Data"
  //         rows="10"
  //         class="smalltextarea"
  //         :disabled="true"
  //       ></b-form-textarea>
  //     </b-form-group> </b-col
  // ></b-row> -->
};
</script>

<style>
</style>
